import Notice from "../../slices/communication/notice/Notice";
import NoticeType from "../../slices/communication/noticeType/NoticeType";
import Poll from "../../slices/communication/poll/Poll";
import Event from "../../slices/communication/event/Event";

const communicationReducer = {
    notice: Notice,
    noticeType: NoticeType,
    poll: Poll,
    event: Event,
};

export default communicationReducer;